module.exports = __webpack_public_path__ + "img/flag-hover.07981e11.svg";